import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';
import AppSnackbar from '@/components/AppSnackbar.vue';
import { useAuthStore } from '@/stores/auth.store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const auth = useAuthStore();
        onMounted(() => {
            // Fetch staff info nếu đã có token (validate token còn hợp lệ)
            if (auth.accessToken && !auth.staff) {
                auth.fetchMe();
            }
        });
        return (_ctx, _cache) => {
            const _component_v_app = _resolveComponent("v-app");
            return (_openBlock(), _createBlock(_component_v_app, null, {
                default: _withCtx(() => [
                    _createVNode(_unref(RouterView)),
                    _createVNode(AppSnackbar)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
